<template>
  <div class="news-wrapper main">
      <breadCrumb></breadCrumb>
      <div class="flex-between">
          <div class="left-section">
              <div class="subtitle school-subtitle">
                  <h2 class="">学校风采</h2>
            </div>
            <div class="school-list">
                <schoolView :cloumn='2' :width='171'></schoolView>
            </div>
              
          </div>
          <div class="right-section">
              <focusBar></focusBar>
          </div>
        </div>
      </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
     @import "../less/news_common.less";
    .news-school {
        background-color:#fff;
        
        .left-section {
            width: 820px;
        }

        .school-list {
            padding: 20px 0 20px 20px;
        }
    }
</style>